export enum UpdateEntityActions {
  ADD,
  REMOVE,
}
